const isMobileDevice = /Mobi|Android|iPhone|iPad|iPod/i.test(navigator.userAgent);
const isSmallScreen = window.innerWidth <= 768;

if (isMobileDevice || isSmallScreen) {
  window.location.href = "http://8.130.102.84:81";
}

import Vue from 'vue';
import { Button, message, Carousel, FormModel, Row, Col, Input, Icon,Modal } from 'ant-design-vue';
const { TextArea } = Input;
// // 注册组件
// Vue.component(Input.name, Input);
// Vue.component(Input.TextArea.name, Input.TextArea);
// /* v1.1.2 */
// Vue.component(Button.name, Button);
// Vue.component(Carousel.name, Carousel);

// Vue.component(FormModel.name, FormModel);
// Vue.component(FormModel.Item.name, FormModel.Item); // 如果是 a-form-model-item
// Vue.component(Row.name, Row);
// Vue.component(Col.name, Col);

/* v1.1.3+ 自动注册Button下组件，如Button.Group */
Vue.use(Button);
Vue.use(Carousel);
Vue.use(FormModel);
Vue.use(Row);
Vue.use(Input);
Vue.use(Input.TextArea);
Vue.use(Icon);
Vue.use(Col);
Vue.use(Modal)
// Vue.component(Input.name, Input);
// Vue.component(TextArea.name, TextArea);

// Vue.component(Col.name, Col);

Vue.prototype.$message = message;
import App from './App.vue';
import router from './router';
import store from './store';
// import Antd from 'ant-design-vue';
// import 'ant-design-vue/dist/antd.css';
import 'intersection-observer';
import './styles/main.less';

// Vue.use(Antd);
Vue.config.productionTip = false;
new Vue({
  router,
  store,
  render: (h) => h(App)
}).$mount('#app');
